import { useLingui } from '@lingui/react'
import { SplitLoader } from '../split-loader'
import { DataPlayer } from '../../types'
import styles from './styles.module.scss'
import { getReprocessingMsg } from '../../utils/operations-utils'

interface Props {
  status: DataPlayer['status']
}

export const ProcessingTask: React.FC<Props> = ({ status = 'succeeded' }) => {
  const { i18n } = useLingui()

  if (!['processing', 'update'].includes(status)) {
    return null
  }

  return (
    <div className={styles.container}>
      <SplitLoader size="small" />
      <p className={styles.text}>{i18n._(getReprocessingMsg(status))}</p>
    </div>
  )
}
